import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axiosInstance';
import { BASE_URL, AUTH_TOKEN_KEY } from "../../utils/constants";
import { getErrorMessage } from '../../utils/helper';

export const login = createAsyncThunk(
  'auth/login',
  async (credentials, { rejectWithValue }) => {
    try {
      const url = `${BASE_URL}user/login`
      const response = await axiosInstance.post(url, credentials);
      // Store token in localStorage
      localStorage.setItem(AUTH_TOKEN_KEY, response.data.data.token);
      return response.data.data.user;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Login failed'));
    }
  }
);

export const logout = createAsyncThunk(
  'auth/logout',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`${BASE_URL}user/logout`);
      // Remove token from localStorage on logout
      localStorage.removeItem(AUTH_TOKEN_KEY);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Logout failed'));
    }
  }
);

export const forgotPassword = createAsyncThunk(
  'auth/forgotPassword',
  async (email, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`${BASE_URL}user/forgot-password`, { email });
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Failed to send reset password email'));
    }
  }
);

export const resetPassword = createAsyncThunk(
  'auth/resetPassword',
  async ({ token, newPassword }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`${BASE_URL}user/reset-password`, { token, newPassword });
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error,'Failed to reset password'));
    }
  }
); 